import { render, staticRenderFns } from "./QualityControlDetail.vue?vue&type=template&id=37dd5abc&scoped=true&"
import script from "./QualityControlDetail.vue?vue&type=script&lang=js&"
export * from "./QualityControlDetail.vue?vue&type=script&lang=js&"
import style0 from "./QualityControlDetail.vue?vue&type=style&index=0&id=37dd5abc&lang=scss&scoped=true&"
import style1 from "./QualityControlDetail.vue?vue&type=style&index=1&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37dd5abc",
  null
  
)

export default component.exports